import { render, staticRenderFns } from "./TranshipmentCouriers.vue?vue&type=template&id=8f9e7aaa&scoped=true"
import script from "./TranshipmentCouriers.vue?vue&type=script&lang=js"
export * from "./TranshipmentCouriers.vue?vue&type=script&lang=js"
import style0 from "./TranshipmentCouriers.vue?vue&type=style&index=0&id=8f9e7aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9e7aaa",
  null
  
)

export default component.exports